/**
 * A list of all product basenames (verticals).
 *
 * @type {{
 * PRO: string,
 * SCHOOLS: string,
 * CAMPS: string,
 * RESORTS: string,
 * GREEK: string,
 * SPORTS: string,
 * CHURCH: string,
 * SHUTTERBUG: string,
 * }}
 */

const BASENAME = {
  PRO: 'pro',
  SCHOOLS: 'schools',
  CAMPS: 'camps',
  RESORTS: 'resorts',
  GREEK: 'greek',
  SPORTS: 'sports',
  CHURCH: 'church',
  SHUTTERBUG: 'shutterbug',
  EVENTS: 'events',
};

export { BASENAME };
